// Aggiungere qui una entry per ogni hostname alternativo.
// I campi non specificati restano null e l'app usa i valori di default dal backend.
// logoApiUrl: usare '/public/logoLogin2' per caricare il logo alternativo (il file deve chiamarsi logo-login_2.png nella cartella images del client sul backend)
const HOSTNAME_BRANDING = {
	'hostmaneDaConfigurarePerAvereLogoAppNomiDiversiSuPaginaLogin': {
		logoApiUrl: '/public/logoLogin2',
		appName: '',
		urlApple: null,
		urlGoogle: null
	}
};

export function useHostnameBranding() {
	return HOSTNAME_BRANDING[window.location.hostname] ?? null;
}
